import {useRouter} from 'next/router';
import {useMemo} from 'react';

import {SEARCH_FILTERS} from '@/src/app/constants/search';
import useCountriesList, {
  LocationType,
  LocationTypes,
} from '@/src/hooks/useCountriesList';
import FilterRow from '@/src/Search/components/FilterRow';
import {getLocationOptions} from '@/src/Search/containers/LocationsSelectFilter';
import {useSearchFilters} from '@/src/Search/utils/useSearchFilters';
import TextLocal from '@/src/textLocal/containers/TextLocal';
import {CheckboxCommon, SimpleCollapse, Text} from '@/src/ui';

import css from '../styles/FilterRow.module.css';

interface AllCandidatesLocationFilterProps {
  locationType?: LocationType;
  userType?: string;
  userId?: string;
}

const AllCandidatesLocationFilter = ({
  locationType,
  userType,
  userId,
}: AllCandidatesLocationFilterProps) => {
  const {locale, query} = useRouter();
  const {countriesList = []} = useCountriesList(
    locationType || LocationTypes.WITH_USERS,
    userId || query?.clinic_id
  );
  const {onMultipleFilterClickHandle} = useSearchFilters(userType);

  const countriesListMemo = useMemo(
    () => getLocationOptions(countriesList, locale),
    [countriesList, locale]
  );

  return (
    <SimpleCollapse
      key={countriesListMemo.length}
      isDisabled={!countriesListMemo.length}
      defaultIsOpen={Boolean(countriesListMemo.length)}
      headTitle={
        <Text
          fontSize={Text.FONT_SIZE.SIZE_16}
          fontWeight={Text.FONT_WEIGHT.MEDIUM}
        >
          <TextLocal id={'profile.location'} />
        </Text>
      }
    >
      <FilterRow>
        <div className={css.checkboxesMaxHeight}>
          {countriesListMemo.map((locationItem) => {
            return (
              <div
                key={`location_${locationItem.value}`}
                className={css.checkboxes}
              >
                {/* @ts-ignore */}
                <CheckboxCommon
                  id={`location_${locationItem.value}`}
                  name={locationItem.label}
                  label={locationItem.label}
                  data-filter-name={SEARCH_FILTERS.ALL_COUNTRIES_IDS}
                  data-value={locationItem.value}
                  checked={
                    !!query[SEARCH_FILTERS.ALL_COUNTRIES_IDS] &&
                    // @ts-ignore
                    JSON.parse([
                      query[SEARCH_FILTERS.ALL_COUNTRIES_IDS],
                    ]).includes(String(locationItem.value))
                  }
                  onChange={onMultipleFilterClickHandle}
                  isSemibold
                />
              </div>
            );
          })}
        </div>
      </FilterRow>
    </SimpleCollapse>
  );
};

export default AllCandidatesLocationFilter;
